export default import.meta.ROLLDOWN_FILE_URL_fJ$$ApkL0T8W1xl5FvH2Eg